//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'AdaptiveVirtualScroller',
  props: {
    items: { type: Array, default: () => [] },
    minItemWidth: { type: [Number, String], default: 160 },
    estimatedItemHeight: { type: Number, default: 80 },
    gap: { type: Number, default: 12 },
    buffer: { type: Number, default: 2 },
    keyField: { type: String, default: 'id' },
    mobileBreakpoint: { type: Number, default: 768 },
    maxRows: { type: Number, default: 5 }
  },
  data() {
    return {
      scrollTop: 0,
      containerWidth: 0,
      resizeObserver: null,
      ticking: false,
      rowHeights: {}
    };
  },
  computed: {
    parsedMinItemWidth() {
      if (!this.containerWidth) return 160;
      if (typeof this.minItemWidth === 'string') {
        const val = this.minItemWidth.trim();
        if (val.endsWith('%')) {
          const percent = parseFloat(val);
          if (percent > 0) {
            const rawPx = (this.containerWidth * percent) / 100;
            return Math.max(1, rawPx - this.gap);
          }
        }
        return parseFloat(val) || 160;
      }
      return this.minItemWidth;
    },

    cols() {
      if (!this.containerWidth) return 1;
      const isMobile =
        this.containerWidth < this.mobileBreakpoint ||
        (typeof window !== 'undefined' && window.innerWidth < this.mobileBreakpoint);

      if (isMobile) return 1;

      const availableCols = Math.floor(
        (this.containerWidth + this.gap) / (this.parsedMinItemWidth + this.gap)
      );
      return Math.max(1, availableCols);
    },

    totalRows() {
      return Math.ceil(this.items.length / this.cols);
    },

    calculatedContainerHeight() {
      const displayRowCount = Math.min(this.totalRows, this.maxRows);
      if (displayRowCount <= 0) return 0;

      let heightSum = 0;
      for (let i = 0; i < displayRowCount; i++) {
        const h = this.rowHeights[i] || this.estimatedItemHeight;
        heightSum += h + this.gap;
      }
      return heightSum;
    },

    scrollerStyle() {
      return {
        height: `${this.calculatedContainerHeight}px`
      };
    },

    rowOffsets() {
      const offsets = [0];
      for (let i = 0; i < this.totalRows; i++) {
        const h = (this.rowHeights[i] || this.estimatedItemHeight) + this.gap;
        offsets.push(offsets[i] + h);
      }
      return offsets;
    },

    totalHeight() {
      return this.rowOffsets[this.totalRows] || 0;
    },

    startRow() {
      const target = Math.max(0, this.scrollTop);
      const offsets = this.rowOffsets;
      let low = 0;
      let high = this.totalRows - 1;
      let start = 0;

      while (low <= high) {
        const mid = Math.floor((low + high) / 2);
        if (offsets[mid] <= target) {
          start = mid;
          low = mid + 1;
        } else {
          high = mid - 1;
        }
      }
      return Math.max(0, start - this.buffer);
    },

    endRow() {
      const end = this.startRow + this.maxRows + this.buffer * 2;
      return Math.min(this.totalRows, end);
    },

    visibleRows() {
      const rows = [];
      for (let r = this.startRow; r < this.endRow; r++) {
        const startIndex = r * this.cols;
        const endIndex = Math.min(this.items.length, startIndex + this.cols);
        rows.push({
          rowIndex: r,
          items: this.items.slice(startIndex, endIndex)
        });
      }
      return rows;
    },

    offsetY() {
      return this.rowOffsets[this.startRow] || 0;
    }
  },
  watch: {
    items: {
      handler() {
        this.$nextTick(this.measureWidth);
      },
      immediate: true
    },
    cols() {
      this.rowHeights = {};
      this.updateRowHeights();
    }
  },
  mounted() {
    this.measureWidth();
    this.initResizeObserver();
  },
  updated() {
    this.updateRowHeights();
  },
  beforeDestroy() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  },
  methods: {
    getItemKey(item, index) {
      return (item && item[this.keyField] !== undefined) ? item[this.keyField] : index;
    },

    updateRowHeights() {
      this.$nextTick(() => {
        const rows = this.$refs.rowElements;
        if (!rows || !rows.length) return;

        rows.forEach((el) => {
          const index = Number(el.dataset.index);
          if (isNaN(index)) return;

          const rect = el.getBoundingClientRect();
          const actualHeight = rect.height;

          if (actualHeight > 0 && this.rowHeights[index] !== actualHeight) {
            this.$set(this.rowHeights, index, actualHeight);
          }
        });
      });
    },

    measureWidth() {
      this.$nextTick(() => {
        const el = this.$refs.scroller;
        if (el) {
          this.containerWidth = el.clientWidth || el.getBoundingClientRect().width;
        }
      });
    },

    initResizeObserver() {
      if (typeof ResizeObserver === 'undefined') return;
      this.resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if (entry.contentRect.width > 0) {
            this.containerWidth = entry.contentRect.width;
          }
        }
      });
      if (this.$refs.scroller) this.resizeObserver.observe(this.$refs.scroller);
    },

    onScroll(e) {
      if (!this.ticking) {
        window.requestAnimationFrame(() => {
          const el = e.target;
          const maxScrollTop = el.scrollHeight - el.clientHeight;
          this.scrollTop = Math.max(0, Math.min(el.scrollTop, maxScrollTop));

          // 触发到顶 / 到底通知事件（供父组件接收监听）
          if (this.scrollTop <= 0) {
            this.$emit('reach-top', e);
          } else if (Math.ceil(this.scrollTop) >= maxScrollTop) {
            this.$emit('reach-bottom', e);
          }

          this.ticking = false;
        });
        this.ticking = true;
      }
    },

    // 滚轮到边界时直接释放锁，让父级接管滚动
    onWheel(e) {
      const el = this.$refs.scroller;
      if (!el) return;

      const { scrollTop, scrollHeight, clientHeight } = el;
      const isTop = scrollTop <= 0;
      const isBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

      // 处于顶部且向上滚，或者处于底部且向下滚时，不干预事件，自然透传给父容器
      if ((isTop && e.deltaY < 0) || (isBottom && e.deltaY > 0)) {
        return; 
      }
    }
  }
};
